// Web Component: AdventPromo
// Gestisce la visualizzazione di promzioni stagionali/natalizie con apertura di modal al click.
// Attributi accettati:
//   - data-modal: selettore CSS del modal da aprire al click
//   - data-inactive: URL dell'immagine da mostrare quando viene cliccato l'elemento
// Eventi emessi: nessuno
// Dipendenze: bootstrap, presenza di elemento img figlio
// Limiti: richiede che il modal sia già presente nel DOM, richiede attributi data specifici
// Utilizzo: usato per promozioni seasonali/natalizie con apertura di modal
class AdventPromo extends HTMLElement {

  connectedCallback() {
    this.addEventListener("click", this.showImage.bind(this));
  }

  showImage = () => {
    setTimeout(() => {
      const image = this.querySelector("img");
      if(!image) {
        console.error("AdventPromo: No image found inside the component.");
        return;
      }

      image.removeAttribute("srcset");
      image.removeAttribute("sizes");
      image.src = this.dataset.inactive;

      setTimeout(() => {
        this.openModal();
      }, 800);
    });
  }

  openModal = () => {
    const modalSelector = this.dataset.modal;
    if(!modalSelector) {
      console.error("AdventPromo: No modal selector provided in data-modal attribute.");
      return;
    }
    const modalElement = document.querySelector(modalSelector);
    if(!modalElement) {
      console.error(`AdventPromo: No modal found for selector ${modalSelector}.`);
      return;
    }

    const bsModal = bootstrap.Modal.getOrCreateInstance(modalElement);
    bsModal.show();
  }
}
customElements.define("advent-promo", AdventPromo);